exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "textarea {\n  width: 100%;\n  border: 1px solid lightgray;\n  min-height: 250px;\n  padding: 5px;\n}\n.html-switch {\n  text-decoration: underline black;\n  cursor: pointer;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/editor/editor.component.less
// module id = ../../../../../src/app/shared/editor/editor.component.less
// module chunks = 2